"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("source-map-support/register");

function falseCommand() {
  return {
    name: 'false',
    synopsis: 'false',
    description: 'Return false',
    execute: function execute() {
      return false;
    }
  };
}

var _default = falseCommand;
exports.default = _default;